import { render, staticRenderFns } from "./campaignCard.vue?vue&type=template&id=78dbe246&scoped=true&"
import script from "./campaignCard.vue?vue&type=script&lang=js&"
export * from "./campaignCard.vue?vue&type=script&lang=js&"
import style0 from "./campaignCard.vue?vue&type=style&index=0&id=78dbe246&scoped=true&lang=css&"
import style1 from "./campaignCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dbe246",
  null
  
)

export default component.exports